<template>
  <div class="ma-0 pa-0" style="width: 100%; height: 100%">
    <!-- <model-obj
      src="../assets/FX7729_FTWLEFT.obj"
      mtl="../assets/FX7729_FTWLEFT.mtl"
      :lights="lights"
    ></model-obj> -->
    <!-- <model-gltf
      src="../assets/1001_0007_0002_predator_right.glb"
      :lights="lights"
    >
    </model-gltf> -->
    <div class="ma-0 pa-0 drop-zone">
      <augmentable-gltf
        v-if="gltf"
        style="width: 100%; height: 100%"
        id="test1-gltf"
        ref="modelGltf"
        :gltfLoader="gltfloader"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
        backgroundAlpha="0"
      >
      </augmentable-gltf>

      <augmentable-obj
        v-if="obj"
        style="width: 100%; height: 100%"
        id="test1-obj"
        ref="modelObj"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :mtl="mtl"
        :manager="manager"
        backgroundAlpha="0"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
      >
      </augmentable-obj>

      <augmentable-fbx
        v-if="fbx"
        style="width: 100%; height: 100%"
        id="test1-fbx"
        ref="modelFbx"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :manager="manager"
        backgroundAlpha="0"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
      >
      </augmentable-fbx>
      <augmentable-stl
        v-if="stl"
        style="width: 100%; height: 100%"
        id="test1-stl"
        ref="modelStl"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :manager="manager"
        backgroundAlpha="0"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
      >
      </augmentable-stl>
      <augmentable-ply
        v-if="ply"
        style="width: 100%; height: 100%"
        id="test1-ply"
        ref="modelPly"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :manager="manager"
        backgroundAlpha="0"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
      >
      </augmentable-ply>
      <augmentable-collada
        v-if="collada"
        style="width: 100%; height: 100%"
        id="test1-collada"
        ref="modelCollada"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :manager="manager"
        backgroundAlpha="0"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
      >
      </augmentable-collada>

      <!-- <augmentable-three
        v-if="threejson"
        style="width: 100%; height: 100%"
        id="test1-threejson"
        ref="modelThreeJson"
        @on-load="test2()"
        :exposure="parseFloat(hdrExposure)"
        :src="src"
        :manager="manager"
        backgroundAlpha="0"
        :environmentImage="hdrItemEnvironment"
        :skyboxImage="hdrItemSkybox"
        :glOptions="{ preserveDrawingBuffer: true }"
      >
      </augmentable-three> -->

      <v-btn
        v-if="augmentableTheme"
        class="drop-zone__prompt"
        @click="inputFileClick()"
        icon
      >
        <md-icon
          class="md-size-3x"
          md-src="/static/assets/svg/white/Upload.svg"
        ></md-icon>
      </v-btn>

      <v-btn
        v-if="!augmentableTheme"
        class="drop-zone__prompt"
        @click="inputFileClick()"
        icon
      >
        <md-icon
          class="md-size-3x"
          md-src="/static/assets/svg/black/Upload.svg"
        ></md-icon>
      </v-btn>

      <input type="file" name="ARfile" id="rr1" class="drop-zone__input" />
    </div>

    <!-- <img
      style="position: absolute; bottom: 30px; left: 30px"
      width="100px"
      height="100px"
      v-if="base64"
      :src="base64"
    /> -->

    <div style="position: absolute; top: 20px; left: 20px">
      <v-btn
        icon
        class="ml-2"
        v-if="!augmentableTheme"
        v-on:click="hdrSettings = !hdrSettings"
      >
        <md-icon
          class="md-size-2x"
          md-src="/static/assets/svg/black/Settings.svg"
        ></md-icon>
      </v-btn>
      <v-btn
        icon
        class="ml-2"
        v-if="augmentableTheme"
        v-on:click="hdrSettings = !hdrSettings"
      >
        <md-icon
          class="md-size-2x"
          md-src="/static/assets/svg/white/Settings.svg"
        ></md-icon>
      </v-btn>
    </div>

    <!-- start viewer settings component -->
    <div
      v-if="hdrSettings"
      class="hdrNavigation ml-10 mt-10"
      style="z-index: 1000"
    >
      <v-container style="margin: 0; padding: 0">
        <v-card
          width="253"
          elevation="3"
          min-height="390"
          style="border-radius: 15px"
          :style="{ background: $vuetify.theme.themes[theme].background }"
        >
          <v-layout>
            <v-flex>
              <v-card
                width="30"
                elevation="0"
                height="366"
                class="ml-1"
                :style="{ background: $vuetify.theme.themes[theme].background }"
              >
                <!-- 1st btn -->
                <div class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0 mt-n3 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="lightf()">
                        mdi-lightbulb-on-outline
                      </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 2nd btn -->
                  <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="circlef()"> tonality </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 3rd btn -->
                  <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-btn icon>
                      <v-icon size="22" @click="mediaf()">
                        mdi-play-circle-outline
                      </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 4th btn -->
                  <!-- <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-btn @click="colorbtnf()" icon>
                      <v-icon size="22"> mdi-palette-outline </v-icon>
                    </v-btn>
                  </v-row> -->
                  <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="boxbtnf()">
                            mdi-palette-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>

                  <!-- 5th btn -->
                  <!-- <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-btn @click="boxbtnf()" icon>
                      <v-icon size="22"> mdi-texture </v-icon>
                    </v-btn>
                  </v-row> -->
                  <!-- 6th btn -->
                  <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="filebtnf()">
                            description
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>
                  <!-- 7th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/filetype.svg"/> -->
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22" @click="photobtnf()">
                            photo_size_select_large
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>
                  <!-- 8th btn -->
                  <v-row class="ma-0 pa-0 mt-2 ml-2">
                    <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/filetype.svg"/> -->
                    <v-btn icon>
                      <v-icon size="22" @click="camerabtnf()">
                        mdi-camera-outline
                      </v-icon>
                    </v-btn>
                  </v-row>
                  <!-- 9th btn -->
                  <v-row class="ma-0 pa-0 mt-3 ml-2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon size="22"> mdi-undo </v-icon>
                        </v-btn>
                      </template>
                      <span>Beta 1.2</span>
                    </v-tooltip>
                  </v-row>
                </div>
              </v-card>
            </v-flex>

            <v-divider
              class="mt-2 mb-5"
              style="border-color: #d3d3d3"
              vertical
            ></v-divider>

            <v-flex>
              <!-- 1st card -->
              <v-card
                v-if="lightbutton"
                width="170"
                elevation="0"
                min-height="325"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-4 ml-2"
              >
                <h4 class="ml-3">Enviorment</h4>
                <p class="ml-3" style="font-size: 11px; font-weight: 650">
                  Active HDR
                </p>

                <v-select
                  :items="hdrFileItems"
                  v-model="hdrItem"
                  item-text="file_name"
                  item-value="file_hdr"
                  dense
                  class="ml-1 mt-n2"
                  rounded
                  outlined
                >
                </v-select>
                <!-- @input="changeEnvironmentImage(hdrItem)" -->

                <p class="ml-3 mt-n3" style="font-size: 11px; font-weight: 650">
                  Tone Mapping
                </p>
                <v-select
                  :items="tonemapping"
                  v-model="tonemap"
                  dense
                  class="ml-1 mt-n2"
                  rounded
                  outlined
                  @input="changeToneMapping(tonemap)"
                >
                </v-select>

                <v-row>
                  <v-col cols="9">
                    <h5 style="margin-top: -1.8em">Use Enviorment as skyBox</h5>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox v-model="asSkybox" style="margin-top: -1.6em">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row class="mt-n2">
                  <v-col cols="9">
                    <h5 style="margin-top: -1.8em">Neutral Light</h5>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="neutralLight"
                      style="margin-top: -1.6em"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <h5 style="margin-top: -1.2em">HDRI light rotation</h5>
                <v-slider
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider>
                <h5 style="margin-top: -1.5em">Brightness</h5>
                <v-slider
                  v-model="hdrExposure"
                  thumb-label
                  min="0"
                  max="2"
                  step="0.05"
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider>
                <!-- <h5 style="margin-top: -1.6em">Brightness</h5>
                <v-slider
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->
                <v-row class="mt-n8">
                  <v-col cols="6">
                    <p>HDR List</p>
                  </v-col>
                  <v-col cols="3">
                    <v-icon
                      @click="hdrlist = !hdrlist"
                      color="blue"
                      class="ml-n5"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                  <v-col cols="2">
                    <v-icon size="22" @click="addHDR()">mdi-plus</v-icon>
                  </v-col>
                </v-row>
                <div v-if="hdrlist">
                  <v-card
                    elevation="0"
                    height="130"
                    class="expand mt-n3"
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                  >
                    <v-card-text>
                      <div v-for="(item, index) in hdrFileItems" :key="index">
                        <v-row class="ma-0 pa-0">
                          <v-col cols="8">
                            <p
                              style="cursor: pointer"
                              @click="hdrSelect(item.file_hdr)"
                            >
                              {{ item.file_name }}
                            </p>
                          </v-col>
                          <v-col cols="4">
                            <v-btn icon @click="deleteHDR(item.id)">
                              <v-icon> mdi-delete-outline </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-divider
                          style="border-color: #d3d3d3"
                          class="ml-2 mr-2"
                        ></v-divider>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-card>

              <!-- 2nd card -->
              <v-card
                v-if="circlebutton"
                width="170"
                elevation="0"
                height="325"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-n3 ml-2"
              >
                <p
                  class="caption-11 mt-8"
                  style="font-weight: 700; opacity: 0.8"
                >
                  Shadow Intensity
                </p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="shadowIntensity"
                    min="0.0"
                    step="0.5"
                    max="10.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n5"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedShadowIntensity }}
                    <v-btn icon>
                      <v-icon> mdi-undo </v-icon>
                    </v-btn>
                  </p>
                </div>
                <p
                  class="caption-11 mt-n3"
                  style="font-weight: 700; opacity: 0.8"
                >
                  Shadow Softness
                </p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="shadowSoftness"
                    min="0.0"
                    step="0.1"
                    max="1.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n5"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedShadowSoftness }}
                    <v-btn icon>
                      <v-icon> mdi-undo </v-icon>
                    </v-btn>
                  </p>
                </div>

                <div style="display: flex" class="mt-n3">
                  <p>Wireframe</p>
                  <v-checkbox class="mt-n2 ml-8"></v-checkbox>
                </div>
                <div style="display: flex" class="mt-n3">
                  <p>Shaded</p>
                  <v-checkbox class="mt-n2 ml-13"></v-checkbox>
                </div>
                <div style="display: flex" class="mt-n3">
                  <p>Double Sided</p>
                  <v-checkbox class="mt-n2 ml-4"></v-checkbox>
                </div>
              </v-card>

              <!-- 3 card -->
              <v-card
                v-if="mediabutton"
                width="170"
                elevation="0"
                min-height="370"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <!-- Animation Settings -->
                <div class="ma-0 pa-0 mt-5">
                  <p class="ml-1 caption-11">
                    Animation Settings<v-icon
                      v-if="!animationAnimationSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationAnimationSettings = !animationAnimationSettings
                      "
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="animationAnimationSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationAnimationSettings = !animationAnimationSettings
                      "
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>
                <div
                  class="ma-0 pa-0 mt-n2 ml-2"
                  v-if="animationAnimationSettings"
                >
                  <p style="font-size: 11px">Base Animation</p>
                  <v-row class="mt-n4 mr-1">
                    <v-select
                      :items="animationList"
                      :item-text="(item) => item.name + ''"
                      :item-value="(item) => item"
                      v-model="animationSelect"
                      dense
                      outlined
                      class="ml-2"
                      rounded
                      @input="animationSelected(animationSelect)"
                    >
                    </v-select>
                  </v-row>

                  <draggable
                    v-model="selectedAnimationList"
                    group="crossfadeAnimations"
                    @start="drag = true"
                    @end="drag = false"
                  >
                    <div
                      class="ma-0 pa-0 mx-2 mt-n3"
                      v-for="(item, index) in selectedAnimationList"
                      :key="index"
                    >
                      <div style="display: flex; font-size: 11px">
                        <div class="ma-0 pa-0">
                          <p class="mr-3">{{ index + 1 }}.</p>
                        </div>
                        <div class="ma-0 pa-0">
                          <p>
                            {{ item.name }}
                          </p>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="ma-0 pa-0 mr-1">
                          <v-icon
                            size="15"
                            @click="removeSelectedAnimationList(index)"
                            >mdi-close</v-icon
                          >
                        </div>
                        <div class="ma-0 pa-0">
                          <v-icon
                            size="15"
                            style="cursor: -webkit-grabbing; cursor: grabbing"
                            >mdi-drag</v-icon
                          >
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <v-row justify="center" class="ma-0 pa-0 mt-n2">
                    <v-menu
                      rounded="lg"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      bottom
                      max-width="200"
                    >
                      <template v-slot:activator="{ on }">
                        <p
                          style="
                            font-size: 11px;
                            color: #419cff;
                            cursor: pointer;
                          "
                          v-on="on"
                        >
                          Select Animationclip<v-icon
                            size="15"
                            class="ml-2"
                            color="primary"
                            >mdi-plus</v-icon
                          >
                        </p>
                      </template>

                      <v-card
                        class="ma-0 pa-0"
                        width="200"
                        height="200"
                        rounded="lg"
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        ><div class="pl-7 pr-7 pt-2 ma-0">
                          <p class="display-22">
                            <strong>Animation Clips</strong>
                          </p>

                          <v-card
                            elevation="0"
                            width="200"
                            height="145"
                            style="overflow-x: hidden"
                            class="ma-0 pa-0 mt-n2 mb-2 expand"
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                          >
                            <div
                              class="ma-0 pa-0"
                              v-for="(
                                item, index
                              ) in computedSelectedAnimationList"
                              :key="index"
                            >
                              <div
                                class="ma-0 pa-0 mt-1 mb-n2"
                                style="display: flex; justify-content: start"
                              >
                                <p
                                  style="cursor: pointer"
                                  class="caption-11"
                                  @click="selectedAnimationListFunc(item)"
                                >
                                  {{ item.name }}
                                </p>
                              </div>
                              <v-divider
                                class="pl-5 pr-5 mt-n3"
                                style="border-color: #d3d3d3"
                              ></v-divider>
                            </div>
                          </v-card>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-row>
                </div>

                <!-- Blend Animation -->
                <div class="ma-0 pa-0">
                  <p class="ml-1 caption-11">
                    Blend Animations<v-icon
                      v-if="!animationBlendAnimations"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationBlendAnimations = !animationBlendAnimations
                      "
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="animationBlendAnimations"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="
                        animationBlendAnimations = !animationBlendAnimations
                      "
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>
                <div
                  class="ma-0 pa-0 ml-2 mr-1"
                  v-if="animationBlendAnimations"
                >
                  <div style="display: flex" class="mt-n1">
                    <div class="ma-0 pa-0">
                      <p style="font-size: 10px">Blend animation</p>
                      <!-- <p style="font-size: 10px">Combined animation</p> -->
                    </div>
                    <v-spacer></v-spacer>
                    <div class="ma-0 pa-0">
                      <v-checkbox
                        v-model="animationCombined"
                        class="mt-n2 mr-n2"
                      >
                      </v-checkbox>
                    </div>
                  </div>

                  <div
                    class="ma-0 pa-0 mt-n4 mb-n6"
                    v-for="(item, index) in selectedAnimationList2"
                    :key="index"
                  >
                    <div class="ml-n2" style="display: flex; font-size: 11px">
                      <div class="ma-0 pa-0">
                        <p>
                          <v-icon
                            class="mr-1"
                            size="12"
                            @click="removeSelectedAnimationList2(index)"
                            >mdi-close</v-icon
                          >{{ item.name }}
                        </p>
                      </div>
                    </div>
                    <div class="ma-0 pa-0 mr-n2 ml-14 mt-n10">
                      <v-slider
                        v-model="animationWeight2[index]"
                        min="0.0"
                        max="1.0"
                        step="0.01"
                        thumb-label
                        track-color="grey"
                        track-fill-color="grey"
                      ></v-slider>
                    </div>
                  </div>

                  <v-row justify="center" class="ma-0 pa-0 mt-n2">
                    <v-menu
                      rounded="lg"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      bottom
                      max-width="200"
                    >
                      <template v-slot:activator="{ on }">
                        <p
                          style="
                            font-size: 11px;
                            color: #419cff;
                            cursor: pointer;
                          "
                          v-on="on"
                        >
                          Select Animationclip<v-icon
                            size="15"
                            class="ml-2"
                            color="primary"
                            >mdi-plus</v-icon
                          >
                        </p>
                      </template>

                      <v-card
                        class="ma-0 pa-0"
                        width="200"
                        height="200"
                        rounded="lg"
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        ><div class="pl-7 pr-7 pt-2 ma-0">
                          <p class="display-22">
                            <strong>Animation Clips</strong>
                          </p>

                          <v-card
                            elevation="0"
                            width="200"
                            height="145"
                            style="overflow-x: hidden"
                            class="ma-0 pa-0 mt-n2 mb-2 expand"
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                          >
                            <div
                              class="ma-0 pa-0"
                              v-for="(
                                item, index
                              ) in computedSelectedAnimationList2"
                              :key="index"
                            >
                              <div
                                class="ma-0 pa-0 mt-1 mb-n2"
                                style="display: flex; justify-content: start"
                              >
                                <p
                                  style="cursor: pointer"
                                  class="caption-11"
                                  @click="selectedAnimationList2Func(item)"
                                >
                                  {{ item.name }}
                                </p>
                              </div>
                              <v-divider
                                class="pl-5 pr-5 mt-n3"
                                style="border-color: #d3d3d3"
                              ></v-divider>
                            </div>
                          </v-card>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-row>
                </div>
                <!-- Animation Controls -->
                <v-card
                  width="170"
                  elevation="0"
                  rounded="lg"
                  min-height="30"
                  class="ma-0 pa-0 ml-1 mt-3 pl-2 pb-2 pt-2 pr-2 mb-4"
                  v-bind:color="isActive ? '#808080' : '#e0e0e0'"
                >
                  <v-card
                    width="170"
                    elevation="0"
                    rounded="lg"
                    height="20"
                    class="ma-0 pa-0 mb-n2"
                    v-bind:color="isActive ? '#808080' : '#e0e0e0'"
                  >
                    <div class="ma-0 pa-0" style="display: flex">
                      <div class="ma-0 pa-0">
                        <p style="font-size: 10px">Animation Controls</p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0 mt-n1">
                        <v-icon
                          v-if="!animationAnimationControls"
                          class="ml-3"
                          size="22"
                          color="primary"
                          @click="
                            animationAnimationControls =
                              !animationAnimationControls
                          "
                          >mdi-menu-right</v-icon
                        >
                        <v-icon
                          v-if="animationAnimationControls"
                          class="ml-3"
                          size="22"
                          color="primary"
                          @click="
                            animationAnimationControls =
                              !animationAnimationControls
                          "
                          >mdi-menu-down</v-icon
                        >
                      </div>
                    </div>
                  </v-card>

                  <div class="ma-0 pa-0 mt-3" v-if="animationAnimationControls">
                    <div class="ma-0 pa-0">
                      <p class="caption-11 mt-n2 mb-n1">Animation Speed</p>
                      <v-slider
                        v-model="animationSpeed"
                        min="0.0"
                        max="1.5"
                        step="0.01"
                        thumb-label
                        track-color="grey"
                        track-fill-color="grey"
                      >
                      </v-slider>
                    </div>
                    <div
                      class="ma-0 pa-0 mt-n6"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="ma-0 pa-0 mt-2">
                        <v-icon size="20" @click="playPreviousAnimation()"
                          >mdi-skip-previous</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0" v-if="!glbAnimationButton">
                        <v-icon size="35" @click="glbAnimation = !glbAnimation"
                          >mdi-play-circle-outline</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0" v-if="glbAnimationButton">
                        <v-icon
                          size="35"
                          color="primary"
                          @click="glbAnimation = !glbAnimation"
                          >mdi-pause</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0 mt-2">
                        <v-icon size="20" @click="playNextAnimation()"
                          >mdi-skip-next</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0 mt-2" v-if="animationLoopButton">
                        <v-icon
                          size="15"
                          color="primary"
                          @click="animationLoop = !animationLoop"
                          >mdi-sync</v-icon
                        >
                      </div>
                      <div class="ma-0 pa-0 mt-2" v-if="!animationLoopButton">
                        <v-icon
                          size="15"
                          @click="animationLoop = !animationLoop"
                          >mdi-sync</v-icon
                        >
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-card>

              <!-- 4 card -->

              <v-card
                v-if="colorbtncard"
                width="170"
                elevation="0"
                height="370"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <v-flex class="ma-0 pa-0">
                  <v-avatar
                    class="mt-4 mr-4 ml-4"
                    v-for="(item, index) in itemscolor"
                    :key="index"
                    :color="item.color"
                    @click="colorf(item)"
                    size="16"
                  ></v-avatar>
                </v-flex>
              </v-card>

              <!-- 5 card -->
              <v-card
                v-if="boxbtncard"
                width="170"
                elevation="0"
                min-height="370"
                max-height="500"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2 expand"
              >
                <v-row class="">
                  <v-col cols="7">
                    <p class="caption-11 pl-2">Materials</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon class="mt-n2">search</v-icon>
                  </v-col>
                  <v-col cols="1">
                    <v-menu offset-y left min-width="145" rounded="lg">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="mt-n2 ml-1"
                          v-on="on"
                          size="20"
                          color="black"
                          >mdi-plus</v-icon
                        >
                      </template>
                      <v-card
                        elevation="4"
                        width="145"
                        class="ma-0 pa-0"
                        height="107"
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        rounded="lg"
                      >
                        <div style="display: flex" class="pl-2 pt-2">
                          <v-icon>mdi-content-copy</v-icon>
                          <p style="font-weight: 450" class="pt-2 pl-2">
                            Duplicate
                          </p>
                        </div>
                        <v-divider
                          style="border-color: #d3d3d3"
                          class="ml-2 mr-2"
                        ></v-divider>
                        <div style="display: flex" class="pl-2 pt-1">
                          <v-icon class="mt-n2">mdi-plus</v-icon>
                          <p style="font-weight: 450" class="ml-2 mt-1">
                            Create new
                          </p>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="1"> </v-col>
                </v-row>
                <p
                  class="ml-2 mt-n6"
                  style="font-weight: 400 !important; font-size: 10px"
                >
                  Select Material
                </p>

                <v-select
                  return-object
                  :items="modelMaterials"
                  v-model="currentMaterial"
                  item-text="name"
                  background-color="#F5F5F5"
                  solo
                  dense
                  style="border-radius: 1.5em !important"
                  label="material"
                  class="ml-1 mr-2 mt-n3 mb-n5"
                >
                </v-select>

                <v-row class="ml-1 mt-n6">
                  <v-col cols="8">
                    <p class="caption-11">Transparency</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="transparency = !transparency"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="transparency" class="mt-n6">
                  <p style="font-size: 10px; font-weight: 500" class="ml-5">
                    Transparency Mode
                  </p>

                  <v-select
                    :items="items"
                    solo
                    dense
                    background-color="#F5F5F5"
                    label="material"
                    class="mb-n6 mt-n3 mr-2"
                    style="border-radius: 1.5em !important"
                  >
                  </v-select>
                  <p
                    style="font-size: 10px; font-weight: 500"
                    class="mt-2 ml-5"
                  >
                    Alpha Mode
                  </p>
                  <div>
                    <v-select
                      :items="items"
                      solo
                      dense
                      style="border-radius: 1.5em !important"
                      background-color="#F5F5F5"
                      label="material"
                      class="mb-n6 mt-n3 mr-2"
                    >
                    </v-select>
                  </div>
                  <p
                    style="font-size: 10px; font-weight: 500"
                    class="mt-2 ml-5"
                  >
                    Alpha
                  </p>
                  <v-slider
                    class="mt-n5"
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <div style="display: flex" class="mt-n8 mb-n4">
                    <v-list
                      :style="{
                        background: $vuetify.theme.themes[theme].background,
                      }"
                    >
                      <v-list-item style="font-size: 11px !important">
                        Use alpha from albedo texture
                      </v-list-item>
                    </v-list>
                    <v-checkbox></v-checkbox>
                  </div>
                </div>
                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Base Color</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="baseColor = !baseColor"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>

                <div v-if="baseColor" class="mt-n6">
                  <div style="display: flex">
                    <v-menu offset-y min-width="100" rounded="lg">
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="30"
                          height="30"
                          color="yellow"
                          class="mt-2 ml-5"
                        >
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="100"
                        height="100"
                        color="#F5F5F5"
                        class="ma-0 pa-0"
                      >
                        <p class="pt-2 pl-2" style="font-size: 12px">
                          Textures
                        </p>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-4"
                    >
                      Texture
                    </p>
                  </div>
                  <v-color-picker
                    mode="rgba"
                    hide-canvas
                    show-swatches
                    v-model="baseColorFactor"
                  ></v-color-picker>
                </div>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Metalness</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="metalness = !metalness"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="metalness" class="mt-n6">
                  <div style="display: flex">
                    <v-menu offset-y min-width="100" rounded="lg">
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="30"
                          height="30"
                          color="yellow"
                          class="mt-2 ml-5"
                        >
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="100"
                        height="100"
                        color="#F5F5F5"
                        class="ma-0 pa-0"
                      >
                        <p class="pt-2 pl-2" style="font-size: 12px">
                          Textures
                        </p>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-4"
                    >
                      Texture
                    </p>
                  </div>
                  <p style="font-size: 10px; font-weight: 500" class="ml-5">
                    Metalic Factor
                  </p>
                  <v-slider
                    class="mt-n5"
                    thumb-label
                    v-model="metallicFactor"
                    min="0"
                    max="1"
                    step="0.01"
                    color="grey"
                  >
                  </v-slider>
                  <p
                    style="font-size: 10px; font-weight: 500"
                    class="ml-5 mt-n6"
                  >
                    Roughness Factor
                  </p>
                  <v-slider
                    class="mt-n5 mb-n8"
                    thumb-label
                    v-model="roughnessFactor"
                    min="0"
                    max="1"
                    step="0.01"
                    color="grey"
                  >
                  </v-slider>
                </div>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Roughness</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon size="22" color="blue" class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Occlusion</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      @click="occlusion = !occlusion"
                      size="22"
                      color="blue"
                      class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
                <div v-if="occlusion" class="mt-n5">
                  <div style="display: flex">
                    <v-menu offset-y min-width="100" rounded="lg">
                      <template v-slot:activator="{ on }">
                        <v-card
                          v-on="on"
                          elevation="0"
                          width="30"
                          height="30"
                          color="blue"
                          class="mt-2 ml-5"
                        >
                        </v-card>
                      </template>
                      <v-card
                        elevation="5"
                        rounded="lg"
                        width="100"
                        height="100"
                        color="#F5F5F5"
                        class="ma-0 pa-0"
                      >
                        <p class="pt-2 pl-2" style="font-size: 12px">
                          Textures
                        </p>
                      </v-card>
                    </v-menu>
                    <p
                      style="font-size: 11px; font-weight: 500"
                      class="ml-3 mt-4"
                    >
                      Texture
                    </p>
                  </div>
                  <p style="font-size: 10px; font-weight: 500" class="ml-5">
                    Strength
                  </p>
                  <v-slider class="mt-n5 mb-n8" thumb-label color="grey">
                  </v-slider>
                </div>

                <v-row class="ml-1 mt-n7">
                  <v-col cols="8">
                    <p class="caption-11">Normals</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon size="22" color="blue" class="ml-n2"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card>

              <!-- 7 card -->

              <!-- 6 card -->
              <v-card
                v-if="filebtncard"
                width="170"
                elevation="0"
                height="370"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <div v-for="(item, index) in filebtns" :key="index">
                  <v-row
                    class="ml-1 mb-3"
                    v-if="item.name === 'Original File' && item.checked"
                    style="
                      background-color: #b3e5fc;
                      height: 2.5em;
                      border-radius: 10px;
                      opacity: 0.8;
                    "
                    @click="selectviewerfile(index)"
                  >
                    <v-col cols="9">
                      <p
                        class="caption-11 mt-n1 pl-n3"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </v-col>
                    <v-col cols="1"> </v-col>
                  </v-row>
                  <v-row
                    class="ml-1 mb-3"
                    v-if="item.name === 'Original File' && !item.checked"
                    @click="selectviewerfile(index)"
                    style="height: 2.5em"
                  >
                    <v-col cols="9">
                      <p
                        class="caption-11 mt-n1"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </v-col>
                    <v-col cols="1"> </v-col>
                  </v-row>
                  <v-row
                    class="ml-1 mt-n1 mb-2"
                    style="
                      background-color: #b3e5fc;
                      height: 2.5em;
                      border-radius: 10px;
                      opacity: 0.8;
                    "
                    v-if="item.checked && item.name !== 'Original File'"
                    @click="selectviewerfile(index)"
                  >
                    <div style="display: flex" class="pl-2 mt-n1">
                      <md-icon
                        v-if="augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg1"
                      />
                      <md-icon
                        v-if="!augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg2"
                      />
                      <p
                        class="caption-11 mt-3 ml-2"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </div>
                  </v-row>
                  <v-row
                    class="ml-1 mt-n1 mb-2"
                    v-if="!item.checked && item.name !== 'Original File'"
                    @click="selectviewerfile(index)"
                  >
                    <div style="display: flex" class="pl-2 mt-n1">
                      <md-icon
                        v-if="augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg1"
                      />
                      <md-icon
                        v-if="!augmentableTheme"
                        class="md-size-x"
                        style="cursor: pointer"
                        :md-src="item.svg2"
                      />
                      <p
                        class="caption-11 mt-3 ml-2"
                        style="font-weight: 700; opacity: 0.8; cursor: pointer"
                      >
                        {{ item.name }}
                      </p>
                    </div>
                  </v-row>
                </div>
              </v-card>
              <!-- 7th card -->
              <v-card
                v-if="photobtncard"
                width="170"
                elevation="0"
                min-height="340"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <v-row class="">
                  <v-col cols="8">
                    <p class="ml-1 mt-n1 caption-11">Resize Textures</p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      class="mt-n2 ml-n2"
                      size="22"
                      color="primary"
                      @click="photomaterialtexture = !photomaterialtexture"
                      >mdi-menu-down</v-icon
                    >
                  </v-col>
                  <v-col cols="1">
                    <v-checkbox class="mt-n2"></v-checkbox>
                  </v-col>
                  <v-col cols="1"> </v-col>
                </v-row>

                <div
                  v-if="photomaterialtexture"
                  class="ma-0 pa-0 mt-n14 ml-1 mb-8"
                >
                  <p style="font-size: 10px; font-weight: 450" class="ml-2">
                    Texture Format
                  </p>
                  <v-select
                    rounded
                    outlined
                    dense
                    label="Same as Sourse"
                    class="mt-n3"
                    :item="textureitem"
                  >
                  </v-select>
                  <!-- <div
                    style="
                      display: flex;
                      height: 2.5em;
                      border-radius: 14px;
                      background-color: #e0e0e0;
                      opacity: 0.9;
                    "
                    class="mt-n4"
                  >
                    <p class="ml-2 mt-2" style="font-weight: 400">
                      Same as Sourse
                    </p>
                    <v-icon size="22" color="primary" class="mt-n1 ml-6"
                      >mdi-menu-down</v-icon
                    >
                  </div> -->
                </div>
                <p class="caption-11 mt-n14 ml-1">Compression quality</p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="Compressionquality"
                    min="0.0"
                    step="0.1"
                    max="1.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n2"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedCompressionquality }}
                    <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                  </p>
                </div>
                <p class="caption-11 mt-n6 ml-1">Downsizing amount</p>
                <div class="ma-0 pa-0" style="display: flex">
                  <v-slider
                    class="mt-n5"
                    v-model="Downsizingamount"
                    min="0.0"
                    step="0.1"
                    max="1.0"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                  <p
                    class="caption-11 mt-n2"
                    style="font-weight: 700; opacity: 0.8"
                  >
                    {{ computedDownsizingamount }}
                    <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                  </p>
                </div>
                <v-card
                  elevation="0"
                  width="175"
                  height="250"
                  color="#e0e0e0"
                  rounded="xl"
                  class="mt-n4"
                >
                  <div style="display: flex" class="pt-4 pl-4 pr-4">
                    <p style="font-size: 11px; font-weight: 570">
                      Texture Info
                    </p>
                    <v-spacer></v-spacer>
                    <v-icon size="24" class="mt-n2" color="black"
                      >mdi-information-outline</v-icon
                    >
                  </div>
                  <div style="display: flex" class="pl-7 pr-4">
                    <p class="caption-11">Format</p>
                    <v-spacer></v-spacer>
                    <p class="caption-11">PNG</p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4 mt-n1">
                    <p class="caption-11">Original</p>
                    <v-spacer></v-spacer>
                    <p class="caption-11">4096 px</p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4 mt-n1">
                    <p class="caption-11">Resized to</p>
                    <v-spacer></v-spacer>
                    <p style="color: #419cff" class="caption-11">1434 px</p>
                  </div>
                  <v-banner
                    color="#00897B"
                    height="1"
                    dark
                    width="175"
                    style="opacity: 0.4"
                  ></v-banner>
                  <div style="display: flex" class="pl-4 pr-4 pt-2">
                    <p style="font-size: 11px; font-weight: 570">File Size</p>
                    <v-spacer></v-spacer>
                    <p style="font-size: 11px; font-weight: 570">improved</p>
                    <p
                      style="font-size: 11px; font-weight: 570; color: #419cff"
                    >
                      :33.33%
                    </p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4">
                    <p class="caption-11">Before:</p>
                    <v-spacer></v-spacer>
                    <p class="caption-11">12 mb</p>
                  </div>
                  <div style="display: flex" class="pl-7 pr-4 mt-n2">
                    <p class="caption-11">After:</p>
                    <v-spacer></v-spacer>
                    <p style="color: #419cff" class="caption-11">8 mb</p>
                  </div>
                </v-card>
                <div
                  class="ml-2 mb-3"
                  style="
                    height: 1.6em;
                    border-radius: 23px;
                    background-color: #419cff;
                    cursor: pointer;
                  "
                >
                  <p style="text-align: center; color: white">Apply</p>
                </div>
              </v-card>
              <!-- 8th card -->
              <v-card
                v-if="camerabtncard"
                width="170"
                elevation="0"
                min-height="340"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
                class="ma-0 pa-0 mt-3 ml-2"
              >
                <!-- Camera Viewer settings -->
                <div class="ma-0 pa-0 mt-6">
                  <p class="ml-1 caption-11">
                    Viewer Settings<v-icon
                      v-if="!cameraViewerSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraViewerSettings = !cameraViewerSettings"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraViewerSettings"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraViewerSettings = !cameraViewerSettings"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>

                <div
                  v-if="cameraViewerSettings"
                  style="display: flex"
                  class="ma-0 pa-0 mt-n3"
                >
                  <div class="ma-0 pa-0 ml-1">
                    <p style="font-size: 14px">Resume last View</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox class="mt-n1 mr-n3"></v-checkbox>
                  </div>
                </div>
                <!-- Synch DetailPage -->
                <div class="ma-0 pa-0 mt-n1">
                  <p class="ml-1 caption-11">
                    Synch & Share<v-icon
                      v-if="!cameraSyncAndShare"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraSyncAndShare = !cameraSyncAndShare"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraSyncAndShare"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraSyncAndShare = !cameraSyncAndShare"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>

                <div
                  v-if="cameraSyncAndShare"
                  style="display: flex"
                  class="ma-0 pa-0 mt-n3"
                >
                  <div class="ma-0 pa-0 ml-1">
                    <p style="font-size: 14px">Synch Detailpage</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox class="mt-n1 mr-n3"></v-checkbox>
                  </div>
                </div>
                <!-- Trunable Controls -->
                <div class="ma-0 pa-0 mt-n1">
                  <p class="ml-1 caption-11">
                    Turnable Controls<v-icon
                      v-if="!cameraTurnableControls"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraTurnableControls = !cameraTurnableControls"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraTurnableControls"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraTurnableControls = !cameraTurnableControls"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>

                <div
                  v-if="cameraTurnableControls"
                  style="display: flex"
                  class="ma-0 pa-0 mt-n3"
                >
                  <div class="ma-0 pa-0 ml-1">
                    <p style="font-size: 14px">Enable Turnable</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div
                    class="ma-0 pa-0"
                    style="display: flex"
                    v-if="directionClockWise"
                  >
                    <div class="ma-0 pa-0">
                      <v-icon @click="directionClockWise = false">
                        mdi-menu-left
                      </v-icon>
                    </div>
                    <div class="ma-0 pa-0 ml-n1">
                      <v-icon
                        @click="directionClockWise = true"
                        color="primary"
                      >
                        mdi-menu-right
                      </v-icon>
                    </div>
                  </div>
                  <div
                    class="ma-0 pa-0"
                    style="display: flex"
                    v-if="!directionClockWise"
                  >
                    <div class="ma-0 pa-0">
                      <v-icon
                        @click="directionClockWise = false"
                        color="primary"
                      >
                        mdi-menu-left
                      </v-icon>
                    </div>
                    <div class="ma-0 pa-0 ml-n1">
                      <v-icon @click="directionClockWise = true">
                        mdi-menu-right
                      </v-icon>
                    </div>
                  </div>
                  <div class="ma-0 pa-0">
                    <v-checkbox
                      v-model="glbRotation"
                      class="mt-n1 mr-n3"
                    ></v-checkbox>
                  </div>
                </div>
                <div
                  class="ma-0 pa-0 mt-n4 mb-n3 ml-1"
                  v-if="cameraTurnableControls"
                >
                  <p class="mt-n1 mb-n1" style="font-size: 14px">
                    Turnable Speed
                  </p>
                  <v-slider
                    v-model="speedAndDirectionOfModel"
                    min="0"
                    max="100"
                    step="5"
                    thumb-label
                    track-color="grey"
                    track-fill-color="grey"
                  >
                  </v-slider>
                </div>
                <!-- Camera Limits -->
                <div class="ma-0 pa-0 mt-n1 mb-n3">
                  <p class="ml-1 caption-11">
                    Camera Limits<v-icon
                      v-if="!cameraCameraLimits"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraCameraLimits = !cameraCameraLimits"
                      >mdi-menu-right</v-icon
                    >
                    <v-icon
                      v-if="cameraCameraLimits"
                      class="ml-3"
                      size="22"
                      color="primary"
                      @click="cameraCameraLimits = !cameraCameraLimits"
                      >mdi-menu-down</v-icon
                    >
                  </p>
                </div>
                <div class="ma-0 pa-0" v-if="cameraCameraLimits">
                  <div
                    class="ma-0 pa-0"
                    v-for="(item, index) in cameraCameraLimitsOptions"
                    :key="index"
                  >
                    <div style="display: flex" class="ma-0 pa-0 mb-n5">
                      <div class="ma-0 pa-0 ml-1">
                        <p style="font-size: 14px">{{ item.title }}</p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0">
                        <v-checkbox
                          v-model="item.checked"
                          class="mt-n1 mr-n3"
                        ></v-checkbox>
                      </div>
                    </div>
                    <div
                      class="ma-0 pa-0 mt-1"
                      v-if="item.checked && item.title != 'Apply Minimum Zoom'"
                    >
                      <div class="ma-0 pa-0 mb-n4 ml-1">
                        <p class="mt-n1 mb-n1" style="font-size: 14px">
                          {{ item.minLimitTitle }}
                        </p>
                        <v-slider
                          v-model="item.minValue"
                          :min="item.minLimit"
                          :max="item.maxLimit"
                          step="5"
                          thumb-label
                          track-color="grey"
                          track-fill-color="grey"
                        >
                        </v-slider>
                      </div>
                      <div class="ma-0 pa-0 mt-n7 mb-n2 ml-1">
                        <p class="mt-n1 mb-n1" style="font-size: 14px">
                          {{ item.maxLimitTitle }}
                        </p>
                        <v-slider
                          v-model="item.maxValue"
                          :min="item.minLimit"
                          :max="item.maxLimit"
                          step="5"
                          thumb-label
                          track-color="grey"
                          track-fill-color="grey"
                        >
                        </v-slider>
                      </div>
                    </div>
                    <div
                      v-if="item.checked && item.title == 'Apply Minimum Zoom'"
                      class="ma-0 pa-0 mt-2"
                      style="display: flex"
                    >
                      <v-btn
                        small
                        height="25"
                        width="72"
                        rounded
                        color="primary"
                        class="ma-0"
                        style="text-transform: none"
                        >Set Min</v-btn
                      >

                      <v-btn
                        small
                        height="25"
                        width="92"
                        rounded
                        color="primary"
                        class="ma-0 ml-2"
                        style="text-transform: none"
                        >Reset Min</v-btn
                      >
                    </div>
                  </div>
                  <!-- due to avoid layout overlay -->
                  <div class="ma-0 pa-0 mb-5"></div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-container>
    </div>
    <!-- end viewer settings component -->
  </div>
</template>

<script>
import AugmentableGltf from "@/components/AugmentableGltf.vue";
import AugmentableObj from "@/components/AugmentableObj.vue";
import AugmentableFbx from "@/components/AugmentableFbx.vue";
import AugmentableStl from "@/components/AugmentableStl.vue";
import AugmentablePly from "@/components/AugmentablePly.vue";
import AugmentableCollada from "@/components/AugmentableCollada.vue";
//import AugmentableThree from "@/components/AugmentableThree.vue";
//import { ModelObj } from "vue-3d-model";

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DDSLoader } from "three/examples/jsm/loaders/DDSLoader";

import { SimpleDropzone } from "simple-dropzone";

// import { USDZExporter } from "three/examples/jsm/exporters/USDZExporter.js";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter.js";

import draggable from "vuedraggable";

import {
  // Object3D,
  // Vector2,
  // Vector3,
  // Color,
  // Scene,
  // Raycaster,
  // WebGLRenderer,
  // PerspectiveCamera,
  // AmbientLight,
  // PointLight,
  // HemisphereLight,
  // DirectionalLight,
  // LinearEncoding,
  LoaderUtils,
  LoadingManager,
  // //
  Clock,
  AnimationMixer,
  // AnimationClip,
  //PMREMGenerator,
  ACESFilmicToneMapping,
  LinearToneMapping,
  ReinhardToneMapping,
  NoToneMapping,
  CineonToneMapping,
  //SpotLight,
  //UnsignedByteType,
  //MeshBasicMaterial,
  //PlaneGeometry,
  //Mesh,
} from "three";
//import { PMREMGenerator, UnsignedByteType } from "three";
//import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { mapState } from "vuex";

export default {
  name: "augmentableViewer",

  components: {
    //ModelObj,
    //ModelGltf,
    AugmentableGltf,
    AugmentableObj,
    AugmentableFbx,
    AugmentableStl,
    AugmentablePly,
    AugmentableCollada,
    //AugmentableThree,

    draggable,
  },
  mounted() {
    //HDR files
    axios
      .get(this.$abServerPath + "/api/hdrfiles/hdrgetallfile/", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Token " + this.getAuthCookie("augmentableUserToken") + "",
        },
      }) //for local "/hdrfile/"
      .then((response) => {
        var i;
        var len;

        var obj = {
          file_hdr: "",
          file_name: "",
          id: "",
        };

        for (i = 0, len = response.data.length; i < len; i++) {
          obj = response.data[i];
          //console.log(response.data[i]);
          obj.file_hdr = this.$abServerPath + "" + response.data[i].file_hdr;
          obj.file_name = "" + response.data[i].file_name;
          obj.id = response.data[i].id;

          //this.hdrSelectItems.push(response.data[i].file_name);
          this.hdrFileItems.push(obj);
        }

        console.log(this.hdrFileItems);
      })
      .catch((error) => {
        console.log(error);
      });

    if (!this.hdrItem) {
      this.hdrItem = "../assets/HDRLabs_FactoryPumps_grey.hdr";
    }

    // document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
    //   const dropZoneElement = inputElement.closest(".drop-zone");
    //   dropZoneElement.addEventListener("dragover", (e) => {
    //     e.preventDefault();
    //   });
    //   ["dragleave", "dragend"].forEach((type) => {
    //     dropZoneElement.addEventListener(type, (e) => {
    //       console.log(e);
    //     });
    //   });
    //   dropZoneElement.addEventListener("drop", (e) => {
    //     e.preventDefault();
    //     if (e.dataTransfer.files.length) {
    //       inputElement.files = e.dataTransfer.files;
    //       //this.goToAddVersionWithFile(e.dataTransfer.files[0]);
    //       this.updateThumbnail(e.dataTransfer.files);
    //     }
    //   });
    // });
    let dropEl = document.querySelector(".drop-zone");
    let inputEl = document.querySelector(".drop-zone__input");
    const dropCtrl = new SimpleDropzone(dropEl, inputEl);
    dropCtrl.on("drop", ({ files }) => {
      if (dropEl.querySelector(".drop-zone__prompt")) {
        dropEl.querySelector(".drop-zone__prompt").remove();
      }
      this.updateThumbnail(files);
    });
  },

  data: function () {
    return {
      src: "",
      mtl: "",
      base64: null,

      model: null,
      fileName: "",
      fileType: "",
      fileSize: 0,
      droppedFiles: "",

      gltf: false,
      obj: false,
      fbx: false,
      stl: false,
      ply: false,
      collada: false,
      threejson: false,

      blobURLs: [],
      gltfloader: null,
      manager: null,

      tonemap: "ACESFilmicToneMapping",
      tonemapping: [
        "NoToneMapping",
        "LinearToneMapping",
        "ReinhardToneMapping",
        "CineonToneMapping",
        "ACESFilmicToneMapping",
      ],
      metalness: false,
      baseColor: false,
      occlusion: false,
      hdrlist: false,

      hdrSettings: false,
      glbRotation: false,
      glbAnimation: false,

      hdrFileItems: [],
      hdrItem: "",
      hdrSelectItems: [],

      hdrItemEnvironment: "",
      hdrItemSkybox: "",

      //animationAnimationSettings
      animationAnimationSettings: false,
      animationAnimationControls: true,
      animationBlendAnimations: false,
      glbAnimationButton: false,
      animationLoopButton: false,

      //bending Animations
      animationActions: [],
      animationSpeed: "1.0",

      //start viewer settings data

      lightbutton: true,
      mediabutton: false,
      circlebutton: false,
      spanbtncard: false,
      boxbtncard: false,
      colorbtncard: false,
      filebtncard: false,
      photobtncard: false,
      camerabtncard: false,
      spanbtns: [
        { name: "Normals" },
        { name: "Albedo" },
        { name: "Reflectivity" },
        { name: "Gloss" },
        { name: "Typography" },
        { name: "Textured" },
      ],

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
        { color: "orange" },
        { color: "grey" },
      ],
      filebtns: [
        {
          name: "Original File",
          checked: false,
        },
        {
          name: "GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLTF",
          checked: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
          // svg1: "/static/assets/svg/white/dracoIcon.svg",
          // svg2: "/static/assets/svg/black/dracoIcon.svg",
        },

        // {
        //   name: "Draco",
        //   checked: true,
        //   svg1: "/static/assets/svg/white/GLBIcon.svg",
        //   svg2: "/static/assets/svg/black/GLBIcon.svg",
        // },
        {
          name: "USD",
          checked: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          name: "USDZ",
          checked: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      downloadFileItems: [
        {
          title: "Original File",
          value: "original",
          valueMax: "",
          max: "2048",
          size: "",
          checked: true,
          list: true,
        },
        {
          title: "Optimized File",
          value: "draco",
          color: "orange",
          checked: false,
          list: true,
        },
        {
          title: "GLB File",
          value: "glb",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },
        {
          title: "GLB File",
          value: "glb",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          title: "GLTF File",
          value: "gltf",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },

        {
          title: "USD File",
          value: "usd",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          title: "USDZ File",
          value: "usdz",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      originalGLBfile: false,
      downloadOriginalFile: false,
      downloadGLB: false,
      downloadGLTF: false,
      downloadUSDZ: false,
      sizeDownloadGLB: "",
      sizeDownloadGLTF: "",

      // filebtns: [
      //   { name: "GLB" },
      //   { name: "Draco" },
      //   { name: "USD" },
      //   { name: "USDZ" },
      // ],

      hdrFile: "",
      hdrFileName: "",
      dialog: "",

      //end viewer settings data

      //viewer settings

      //rotation speed and direction
      speedAndDirectionOfModel: "20",
      skipWatchOfSD: false,
      directionClockWise: true,
      speedDirection: "",

      //rotation speed and direction

      //animation
      animationLoop: false,
      animationList: [],
      selectedAnimationList: [],
      selectedAnimationList2: [],
      playSelectedAnimationList: [],
      animationInterval: "",
      animationSelect: "",
      animationCombined: false,
      animationSelect2nd: "",
      //animation
      animationWeight: [],
      animationWeight2: [],

      interval1: "",

      //materials
      modelMaterials: [],
      currentMaterial: [],
      roughnessFactor: "",
      metallicFactor: "",
      baseColorFactor: "",
      //materials

      //shadow settings
      shadowIntensity: "0.0",
      shadowSoftness: "0.0",
      computedShadowIntensity: "0.0",
      computedShadowSoftness: "0.0",
      //shadow settings

      //HDR settings
      hdrExposure: "0.7",
      asSkybox: false,
      neutralLight: true,
      //HDR setttings

      //viewer settings
      clock: new Clock(),
      //mixer: null,
    };
  },

  computed: {
    ...mapState(["augmentableTheme"]),
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    computedSelectedAnimationList() {
      var result = this.animationList.filter(
        (item) => !this.selectedAnimationList.includes(item)
      );
      return result;
    },
    computedSelectedAnimationList2() {
      var result = this.animationList.filter(
        (item) => !this.selectedAnimationList2.includes(item)
      );
      return result;
    },
  },

  watch: {
    hdrItem: function (val) {
      this.hdrItemEnvironment = val;
      if (this.asSkybox) {
        this.hdrItemSkybox = val;
      }
    },
    asSkybox: function (val) {
      if (val) {
        this.hdrItemSkybox = this.hdrItem;
      } else {
        this.hdrItemSkybox = "";
      }
    },
    gltf: function (val) {
      if (val === true) {
        this.obj = false;
        this.fbx = false;
        this.stl = false;
        this.ply = false;
        this.collada = false;
        this.threejson = false;
      }
    },
    obj: function (val) {
      if (val === true) {
        this.gltf = false;
        this.fbx = false;
        this.stl = false;
        this.ply = false;
        this.collada = false;
        this.threejson = false;
      }
    },
    fbx: function (val) {
      if (val === true) {
        this.gltf = false;
        this.obj = false;
        this.stl = false;
        this.ply = false;
        this.collada = false;
        this.threejson = false;
      }
    },
    stl: function (val) {
      if (val === true) {
        this.gltf = false;
        this.obj = false;
        this.fbx = false;
        this.ply = false;
        this.collada = false;
        this.threejson = false;
      }
    },
    ply: function (val) {
      if (val === true) {
        this.gltf = false;
        this.obj = false;
        this.fbx = false;
        this.stl = false;
        this.collada = false;
        this.threejson = false;
      }
    },
    collada: function (val) {
      if (val === true) {
        this.gltf = false;
        this.obj = false;
        this.fbx = false;
        this.stl = false;
        this.ply = false;
        this.threejson = false;
      }
    },
    threejson: function (val) {
      if (val === true) {
        this.gltf = false;
        this.obj = false;
        this.fbx = false;
        this.stl = false;
        this.ply = false;
        this.collada = false;
      }
    },
    // hdrExposure: function (val) {
    //   let d = document.getElementById("test1");
    //   if (d) {
    //     console.log("rrrr");
    //     console.log(d);
    //     console.log(val);
    //     d.setAttribute("exposure", val);
    //     console.log(d);
    //     //d.__vue__.renderer.toneMappingExposure = parseFloat(val);
    //   }
    // },

    glbAnimation: function (val) {
      if (this.animationCombined === false) {
        if (val === true && !this.animationLoop) {
          if (this.selectedAnimationList.length !== 0) {
            this.glbAnimationButton = true;

            this.animationActions = [];
            this.model.mixer.stopAllAction();
            this.model.mixer.uncacheRoot(this.model.modelLoad.scene);

            this.selectedAnimationList.forEach(
              function (animation) {
                this.animationActions.push(
                  this.model.mixer.clipAction(animation)
                );
              }.bind(this)
            );

            this.animationActions.forEach(function (action, index) {
              if (index === 0) {
                action.enabled = true;
                action.setEffectiveTimeScale(1);
                action.setEffectiveWeight(1);
              } else {
                action.enabled = true;
                action.setEffectiveTimeScale(1);
                action.setEffectiveWeight(0);
              }
              action.play();
            });

            let count = 0;
            this.interval1 = setInterval(() => {
              if (count < this.animationActions.length - 1) {
                count++;
              } else {
                count = 0;
              }
              this.animationActions.forEach(function (action, index) {
                if (index === count) {
                  action.enabled = true;
                  action.setEffectiveTimeScale(1);
                  action.setEffectiveWeight(1);
                } else {
                  action.enabled = true;
                  action.setEffectiveTimeScale(1);
                  action.setEffectiveWeight(0);
                }
              });
            }, 1000 * this.selectedAnimationList[count].duration);
          } else {
            this.glbAnimationButton = false;
            clearInterval(this.interval1);
            this.animationActions = [];
            this.model.mixer.stopAllAction();
            this.model.mixer.uncacheRoot(this.model.modelLoad.scene);
          }
        } else if (val === true && this.animationLoop) {
          if (this.selectedAnimationList.length !== 0) {
            this.glbAnimationButton = true;

            this.animationActions = [];
            this.model.mixer.stopAllAction();
            this.model.mixer.uncacheRoot(this.model.modelLoad.scene);

            this.selectedAnimationList.forEach(
              function (animation) {
                this.animationActions.push(
                  this.model.mixer.clipAction(animation)
                );
              }.bind(this)
            );

            this.animationActions.forEach(function (action) {
              action.play();
            });
          } else {
            this.glbAnimationButton = false;
            clearInterval(this.interval1);
            this.animationActions = [];
            this.model.mixer.stopAllAction();
            this.model.mixer.uncacheRoot(this.model.modelLoad.scene);
          }
        } else if (val === false) {
          this.glbAnimationButton = false;
          clearInterval(this.interval1);
          this.animationActions.forEach(function (action) {
            action.stop();
          });
          this.glbAnimationButton = false;
        }
      } else {
        if (val === true) {
          this.glbAnimationButton = true;

          this.animationActions = [];
          this.model.mixer.stopAllAction();
          this.model.mixer.uncacheRoot(this.model.modelLoad.scene);

          this.selectedAnimationList2.forEach(
            function (animation) {
              this.animationActions.push(
                this.model.mixer.clipAction(animation)
              );
            }.bind(this)
          );

          this.animationActions.forEach(function (action) {
            action.play();
          });
        } else {
          this.glbAnimationButton = false;
          this.animationActions = [];
          this.model.mixer.stopAllAction();
          this.model.mixer.uncacheRoot(this.model.modelLoad.scene);
        }
      }
    },
    animationSpeed: function (val) {
      this.model.mixer.timeScale = parseFloat(val);
    },

    animationWeight2: function (val) {
      this.animationActions.forEach(function (action, index) {
        action.enabled = true;
        action.setEffectiveTimeScale(1);
        action.setEffectiveWeight(val[index]);
      });
    },
  },

  methods: {
    // findAndRemoveElm(arr,elm){
    //   let
    //   for(var i=0;i<arr.length;i++){
    //     if(elm === arr[i]){
    //       arrT=;
    //     }
    //   }
    // },
    async updateThumbnail(files) {
      this.droppedFiles = files;
      //let filesMap = new Map();
      //console.log(files);
      // let iMap;
      // let lenMap;
      // for(iMap=0;lenMap=files.length;iMap<lenMap){
      //   this.extentions.push(files[iEx].name.split(".").pop());
      // }

      let rootFile;
      let rootPath;

      let objFile;
      let mtlFile;

      let fbxFile;
      let stlFile;
      let plyFile;
      let colladaFile;
      let threejsonFile;

      Array.from(files).forEach(([path, file]) => {
        if (file.name.match(/\.(gltf|glb)$/)) {
          this.gltf = true;
          rootFile = file;
          rootPath = path.replace(file.name, "");

          let filename = file.name;
          this.fileName = filename.replace(/\.[^/.]+$/, "");
          if (file.name.match(/\.(gltf)$/)) {
            this.fileType = "gltf";
          } else {
            this.fileType = "glb";
          }
        }
      });

      if (!rootFile) {
        Array.from(files).forEach(([path, file]) => {
          if (file.name.match(/\.(obj)$/)) {
            objFile = file;
            rootPath = path.replace(file.name, "");

            let filename = file.name;
            this.fileName = filename.replace(/\.[^/.]+$/, "");
            this.fileType = "obj";
          }
          if (file.name.match(/\.(mtl)$/)) {
            mtlFile = file;
            rootPath = path.replace(file.name, "");
          }
        });
        //console.log("kkkkk");
        //console.log(files);
        //this.onError("No .gltf or .glb asset found.");
      }
      if (!rootFile && !objFile) {
        Array.from(files).forEach(([path, file]) => {
          if (file.name.match(/\.(fbx)$/)) {
            this.fbx = true;
            fbxFile = file;
            rootPath = path.replace(file.name, "");

            let filename = file.name;
            this.fileName = filename.replace(/\.[^/.]+$/, "");
            this.fileType = "fbx";
          }
        });
      }

      if (!rootFile && !objFile && !fbxFile) {
        Array.from(files).forEach(([path, file]) => {
          if (file.name.match(/\.(stl)$/)) {
            this.stl = true;
            stlFile = file;
            rootPath = path.replace(file.name, "");

            let filename = file.name;
            this.fileName = filename.replace(/\.[^/.]+$/, "");
            this.fileType = "stl";
          }
        });
      }

      if (!rootFile && !objFile && !fbxFile && !stlFile) {
        Array.from(files).forEach(([path, file]) => {
          if (file.name.match(/\.(ply)$/)) {
            this.ply = true;
            plyFile = file;
            rootPath = path.replace(file.name, "");

            let filename = file.name;
            this.fileName = filename.replace(/\.[^/.]+$/, "");
            this.fileType = "ply";
          }
        });
      }

      if (!rootFile && !objFile && !fbxFile && !stlFile && !plyFile) {
        Array.from(files).forEach(([path, file]) => {
          if (file.name.match(/\.(dae)$/)) {
            this.collada = true;
            colladaFile = file;
            rootPath = path.replace(file.name, "");

            let filename = file.name;
            this.fileName = filename.replace(/\.[^/.]+$/, "");
            this.fileType = "dae";
          }
        });
      }

      if (
        !rootFile &&
        !objFile &&
        !fbxFile &&
        !stlFile &&
        !plyFile &&
        !colladaFile
      ) {
        Array.from(files).forEach(([path, file]) => {
          if (file.name.match(/\.(json)$/)) {
            this.threejson = true;
            threejsonFile = file;
            rootPath = path.replace(file.name, "");

            let filename = file.name;
            this.fileName = filename.replace(/\.[^/.]+$/, "");
            this.fileType = "json";
          }
        });
      }

      //file size
      this.fileSize = 0;
      Array.from(files).forEach(([path, file]) => {
        this.fileSize = this.fileSize + file.size;
        //console.log("" + (file.size / (1024 * 1024)).toFixed(2) + "MB");
        console.log(path);
      });
      console.log("" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB");
      //file size

      let url;
      let url1;
      if (rootFile) {
        url = URL.createObjectURL(rootFile);
        //this.src = url;
      } else if (objFile) {
        this.obj = false;
        await this.sleep(5);
        this.obj = true;
        url = URL.createObjectURL(objFile);
        if (mtlFile) {
          url1 = URL.createObjectURL(mtlFile);
        }
      } else if (fbxFile) {
        this.fbx = true;
        url = URL.createObjectURL(fbxFile);
      } else if (stlFile) {
        this.stl = true;
        url = URL.createObjectURL(stlFile);
      } else if (plyFile) {
        this.ply = true;
        url = URL.createObjectURL(plyFile);
      } else if (colladaFile) {
        this.collada = true;
        url = URL.createObjectURL(colladaFile);
      } else if (threejsonFile) {
        this.threejson = true;
        url = URL.createObjectURL(threejsonFile);
      }

      const baseURL = LoaderUtils.extractUrlBase(url);

      //const manager = new LoadingManager();
      this.manager = new LoadingManager();

      // if (objFile) {
      //   alert("jjh");
      // }
      if (objFile) {
        this.manager.addHandler(/\.dds$/i, new DDSLoader());
      }

      // Intercept and override relative URLs.
      this.manager.setURLModifier((url, path) => {
        // URIs in a glTF file may be escaped, or not. Assume that assetMap is
        // from an un-escaped source, and decode all URIs before lookups.
        // See: https://github.com/donmccurdy/three-gltf-viewer/issues/146
        const normalizedURL =
          rootPath +
          decodeURI(url)
            .replace(baseURL, "")
            .replace(/^(\.?\/)/, "");

        //if(normalizedURL)

        console.log(normalizedURL);

        if (files.has(normalizedURL)) {
          const blob = files.get(normalizedURL);
          const blobURL = URL.createObjectURL(blob);
          this.blobURLs.push(blobURL);
          return blobURL;
        }

        return (path || "") + url;
      });

      //let managerGLTf = this.manager
      this.gltfloader = new GLTFLoader(this.manager).setCrossOrigin(
        "anonymous"
      );

      console.log(this.manager);

      console.log(url);
      console.log("lll");

      if (rootFile) {
        this.src = url;
      } else if (objFile) {
        this.src = url;
        if (mtlFile) {
          this.mtl = url1;
        }
      } else if (fbxFile) {
        this.src = url;
      } else if (stlFile) {
        this.src = url;
      } else if (plyFile) {
        this.src = url;
      } else if (colladaFile) {
        this.src = url;
      } else if (threejsonFile) {
        this.src = url;
      }

      if (rootFile) {
        URL.revokeObjectURL(rootFile);
      } else if (objFile) {
        URL.revokeObjectURL(objFile);
        if (mtlFile) {
          URL.revokeObjectURL(mtlFile);
        }
      } else if (fbxFile) {
        URL.revokeObjectURL(fbxFile);
      } else if (stlFile) {
        URL.revokeObjectURL(stlFile);
      } else if (plyFile) {
        URL.revokeObjectURL(plyFile);
      } else if (colladaFile) {
        URL.revokeObjectURL(colladaFile);
      } else if (threejsonFile) {
        URL.revokeObjectURL(threejsonFile);
      }

      //this.view(rootFile, rootPath, fileMap);

      // // let iEx;
      // // let lenEx;
      // // for(iEx=0;lenEx=files.length;iEx<lenEx){
      // //   this.extentions.push(files[iEx].name.split(".").pop());
      // // }
      // // console.log(this.extentions);

      // //this.fileUploadName = file.name;
      // //this.fileUploadName = this.fileUploadName.replace(/\.[^/.]+$/, "");

      // //this.version = "VERSION 1.0";

      // this.extention = file.name.split(".").pop();

      // if (this.extention === "glb" || this.extention === "gltf") {
      //   this.gltf = true;
      //   //this.src = "../assets/damaged_helmet/scene.gltf";
      //   this.src = file;
      //   console.log("ffffPath");
      //   console.log(file.path);
      //   console.log(this.src);

      //   // thumbnailElement.addEventListener("load", () => {
      //   //   this.animationList = thumbnailElement.availableAnimations;
      //   //   this.animationSelect = this.animationList[0];

      //   //   URL.revokeObjectURL(thumbnailElement.src);
      //   // });
      // }

      // // //fileSize
      // // this.file = file;

      // // this.fileSize = this.file.size;
      // // this.fileSizeCalc();
      // // //fileSize

      // //obj
      // if (this.extention === "obj") {
      //   this.obj = true;
      //   this.src = URL.createObjectURL(file);
      //   //this.obj2gltf();
      //   //this.mtlFileValue = true;
      //   // this.objFile = file;
      //   // this.obj2glb();
      // }
      // //obj

      // //fbx
      // // if (this.extention === "fbx") {
      // //   this.fbxFile = file;
      // //   this.fbx2glb();
      // // }
      // //fbx

      // // if (this.extention === "zip") {
      // //   this.remeshObj();
      // // }
    },

    onError(error) {
      let message = (error || {}).message || error.toString();
      if (message.match(/ProgressEvent/)) {
        message =
          "Unable to retrieve this file. Check JS console and browser network tab.";
      } else if (message.match(/Unexpected token/)) {
        message = `Unable to parse file content. Verify that this file is valid. Error: "${message}"`;
      } else if (error && error.target && error.target instanceof Image) {
        message = "Missing texture: " + error.target.src.split("/").pop();
      }
      window.alert(message);
      console.error(error);
    },

    async test2() {
      this.hdrItemEnvironment =
        "/static/assets/landingAsset/venice_sunset_2k.hdr";

      //let model;
      if (this.gltf) {
        this.model = this.$refs.modelGltf;
      } else if (this.obj) {
        this.model = this.$refs.modelObj;
      } else if (this.fbx) {
        this.model = this.$refs.modelFbx;
      } else if (this.stl) {
        this.model = this.$refs.modelStl;
      } else if (this.ply) {
        this.model = this.$refs.modelPly;
      } else if (this.collada) {
        this.model = this.$refs.modelCollada;
      } else if (this.threejson) {
        this.model = this.$refs.modelThreeJson;
      }

      // const exporter = new USDZExporter();
      // const arraybuffer = await exporter.parse(this.model.scene);
      // const blob = new Blob([arraybuffer], {
      //   type: "application/octet-stream",
      // });

      // var link = document.createElement("a");
      // link.download = "hello.usdz";
      // link.rel = "ar";
      // link.href = URL.createObjectURL(blob);
      // link.click();

      // // 1 second delay for download else you will lose download track (multiple download)
      // await this.sleep(500);

      // this.exportGLTF(this.model.scene, true);

      this.selectedAnimationList = [];
      this.selectedAnimationList2 = [];
      this.model.mixer = null;
      this.animationList = [];
      this.animationSelect = "";
      this.animationActions = [];

      if (this.fileType === "glb" || this.fileType === "gltf") {
        if (this.model.modelLoad.animations) {
          this.model.mixer = new AnimationMixer(this.model.modelLoad.scene);
          this.animationList = this.model.modelLoad.animations;

          if (this.animationList.length > 0) {
            this.animationSelect = this.animationList[0];

            this.animationActions.push(
              this.model.mixer.clipAction(this.animationSelect)
            );
          }
        } else {
          console.log("no animations");
        }
      } else {
        console.log("no animations");
      }
      // let d = document.getElementById("test1");
      // //console.log(d);
      // //console.log(d.__vue__.scene.visible);
      // // d.__vue__.scene.visible = false;
      // // d.__vue__.scene.visible = false;
      // let model = d.__vue__.model;
      // console.log(model.animations);
      // const clip = AnimationClip.findByName(
      //   this.model.modelLoad.animations,
      //   "All Animations"
      // );

      // console.log(clip);
      // this.mixer = new AnimationMixer(this.model.modelLoad.scene);
      // //const mixer = new AnimationMixer(model.scene);

      // const animationAction = this.mixer.clipAction(clip);
      // // const animationAction = this.mixer.clipAction(model.animations[0]);
      // // console.log(model.animations[0]);
      // // console.log(animationAction);
      // animationAction.setEffectiveTimeScale(1);
      // animationAction.setEffectiveWeight(1);
      // animationAction.enabled = true;
      // // if (this.mixer) this.mixer.update(this.model.clock1.getDelta());
      // // animationAction.play();
      // // if (this.mixer) this.mixer.update(this.model.clock1.getDelta());
      // animationAction.play();
      // // if (this.mixer) this.mixer.update(this.model.clock1.getDelta());
      // // animationAction.play();
      // // if (this.mixer) this.mixer.update(this.model.clock1.getDelta());
      // // animationAction.play();
      // // if (this.mixer) this.mixer.update(this.model.clock1.getDelta());
      // // animationAction.play();
      // console.log(this.model.clock1);
      // //animationAction.enabled = true;
      // //animationAction.setEffectiveTimeScale(1);
      // //animationAction.setEffectiveWeight(1);

      // //animationAction.reset();

      // animationAction.play();

      //this.mixerUpdate();
      this.blobURLs.forEach(URL.revokeObjectURL);

      //console.log(model.renderer);

      this.$emit("on-model-load");

      // await this.sleep(5);
      // console.log("tt");
      // console.log(this.model);
      // this.base64 = this.model.renderer.domElement.toDataURL("image/png", 1);

      //it's working
      //let filepng = await fetch(this.base64).then((r) => r.blob());

      // .then(
      //   (blobFile) => new Blob([blobFile], { type: "image/png" })
      // );
      // var a = document.createElement("a"); //Create <a>
      // a.href = this.base64; //Image Base64 Goes here
      // a.download = "Image.png"; //File name Here
      // a.click(); //Downloaded file
      // console.log("image");
      // console.log(this.base64);

      // a.href = URL.createObjectURL(filepng);
      // a.download = "screenshot.png";
      // a.click();
    },

    async animationSelected(x) {
      if (this.model) {
        console.log("rr");
        console.log(x);
        this.model.mixer.stopAllAction();
        this.model.mixer.uncacheRoot(this.model.modelLoad.scene);
        this.animationActions.push(this.model.mixer.clipAction(x));
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },

    async selectedAnimationListFunc(item) {
      item.weight = parseFloat("1.0");
      this.animationWeight.push(item.weight);
      this.selectedAnimationList.push(item);
      if (this.glbAnimation === true) {
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },
    async removeSelectedAnimationList(index) {
      this.animationWeight.splice(index, 1);
      this.selectedAnimationList.splice(index, 1);
      if (this.glbAnimation === true) {
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },

    async selectedAnimationList2Func(item) {
      item.weight = parseFloat("1.0");
      this.animationWeight2.push(item.weight);
      this.selectedAnimationList2.push(item);
      if (this.glbAnimation === true) {
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },
    async removeSelectedAnimationList2(index) {
      this.animationWeight2.splice(index, 1);
      this.selectedAnimationList2.splice(index, 1);
      if (this.glbAnimation === true) {
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },

    exportGLTF(input, binaryBool) {
      const gltfExporter = new GLTFExporter();

      const options = {
        //trs: document.getElementById( 'option_trs' ).checked,
        //onlyVisible: document.getElementById( 'option_visible' ).checked,
        //truncateDrawRange: document.getElementById( 'option_drawrange' ).checked,
        binary: binaryBool,
        //maxTextureSize: Number( document.getElementById( 'option_maxsize' ).value ) || Infinity // To prevent NaN value
      };
      let save = this.saveArrayBuffer;
      let saveString = this.saveString;
      gltfExporter.parse(
        input,
        function (result) {
          alert("ffff");
          if (result instanceof ArrayBuffer) {
            alert("rrr");
            save(result, "scene.glb");
          } else {
            const output = JSON.stringify(result, null, 2);
            console.log(output);
            saveString(output, "scene.gltf");
          }
        },
        options
      );
    },
    save(blob, filename) {
      var link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();

      // URL.revokeObjectURL( url ); breaks Firefox...
    },

    saveString(text, filename) {
      this.save(new Blob([text], { type: "text/plain" }), filename);
    },

    saveArrayBuffer(buffer, filename) {
      this.save(
        new Blob([buffer], { type: "application/octet-stream" }),
        filename
      );
    },

    downloadGltf() {
      let model;
      if (this.gltf) {
        model = this.$refs.modelGltf;
      } else if (this.obj) {
        model = this.$refs.modelObj;
      } else if (this.fbx) {
        model = this.$refs.modelFbx;
      } else if (this.stl) {
        model = this.$refs.modelStl;
      } else if (this.ply) {
        model = this.$refs.modelPly;
      } else if (this.collada) {
        model = this.$refs.modelCollada;
      } else if (this.threejson) {
        model = this.$refs.modelThreeJson;
      }

      this.exportGLTF(model.scene, true);
    },

    // mixerUpdate() {
    //   if (this.mixer) {
    //     this.mixer.update(this.clock1.getDelta());
    //     this.mixerUpdate();
    //   }
    // },

    async changeToneMapping(toneMap) {
      let d;
      if (this.gltf) {
        d = document.getElementById("test1-gltf");
      } else if (this.obj) {
        d = document.getElementById("test1-obj");
      } else if (this.fbx) {
        d = document.getElementById("test1-fbx");
      } else if (this.stl) {
        d = document.getElementById("test1-stl");
      } else if (this.ply) {
        d = document.getElementById("test1-ply");
      } else if (this.collada) {
        d = document.getElementById("test1-collada");
      } else if (this.threejson) {
        d = document.getElementById("test1-threejson");
      }

      let renderer = d.__vue__.renderer;
      if (d) {
        if (toneMap === "NoToneMapping") {
          renderer.toneMapping = NoToneMapping;
        } else if (toneMap === "LinearToneMapping") {
          renderer.toneMapping = LinearToneMapping;
        } else if (toneMap === "ReinhardToneMapping") {
          renderer.toneMapping = ReinhardToneMapping;
        } else if (toneMap === "CineonToneMapping") {
          renderer.toneMapping = CineonToneMapping;
        } else if (toneMap === "ACESFilmicToneMapping") {
          renderer.toneMapping = ACESFilmicToneMapping;
        }

        this.hdrItemEnvironment = "";
        await this.sleep(1);
        this.hdrItemEnvironment = this.hdrItem;
      }
    },

    //start settings functions
    //   1st btn
    lightf() {
      this.lightbutton = true;
      this.circlebutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },
    //   2nd btn
    circlef() {
      this.circlebutton = true;
      this.lightbutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },
    //3rd btn
    mediaf() {
      this.mediabutton = true;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },
    //4th btn
    colorbtnf() {
      this.colorbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },
    //5th btn
    boxbtnf() {
      this.boxbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },
    //6th btn
    filebtnf() {
      this.filebtncard = true;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.photobtncard = false;
      this.camerabtncard = false;
    },
    //7th btn
    photobtnf() {
      this.photobtncard = true;
      this.filebtncard = false;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.camerabtncard = false;
    },
    //8th btn
    camerabtnf() {
      this.camerabtncard = true;
      this.photobtncard = false;
      this.filebtncard = false;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
    },
    colorf(x) {
      alert(x.color);
    },
    //end settings functions

    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");

@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

.hdrNavigation {
  top: 0;
  left: 0;

  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";
}

.drop-zone {
  width: 100%;
  height: 100%;
  //min-height: 20vh;
  cursor: pointer;
}

.drop-zone__input {
  display: none;
}

.drop-zone__prompt {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
</style>
